import { render } from "./SpotFooter.vue?vue&type=template&id=7bbb0e98&scoped=true"
import script from "./SpotFooter.vue?vue&type=script&lang=js"
export * from "./SpotFooter.vue?vue&type=script&lang=js"

import "./SpotFooter.vue?vue&type=style&index=0&id=7bbb0e98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bbb0e98"]])

export default __exports__